import { render, staticRenderFns } from "./storePriceManageAction.vue?vue&type=template&id=22f83fa9&scoped=true"
import script from "./storePriceManageAction.vue?vue&type=script&lang=js"
export * from "./storePriceManageAction.vue?vue&type=script&lang=js"
import style0 from "./storePriceManageAction.vue?vue&type=style&index=0&id=22f83fa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f83fa9",
  null
  
)

export default component.exports